module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h1', [_vm._v("安装使用(webpack)")]), _vm._v(" "), _c('div', {
    staticClass: "warning"
  }, [_c('p', [_vm._v("如果你从没使用过 "), _c('code', [_vm._v("VUX")]), _vm._v("，请参考 "), _c('router-link', {
    attrs: {
      "to": "/zh-CN/install/biolerplate.html"
    }
  }, [_vm._v("快速入门")]), _vm._v("。"), _c('br'), _c('br'), _vm._v("\n不推荐使用 "), _c('code', [_vm._v("umd")]), _vm._v(" 方式引用组件，但是如果不得不使用，可以参考 "), _c('router-link', {
    attrs: {
      "to": "/zh-CN/install/umd.html"
    }
  }, [_vm._v("umd 构建")])], 1)]), _vm._v(" "), _c('p', [_vm._v("直接安装或者更新：")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('p', [_vm._v("如果你是从"), _c('code', [_vm._v("0.x")]), _vm._v("更新，请参考： "), _c('router-link', {
    staticStyle: {
      "color": "#42b983"
    },
    attrs: {
      "to": "/zh-CN/install/upgrade-to-vux2.html"
    }
  }, [_vm._v("更新到"), _c('code', [_vm._v("2.x")])])], 1), _vm._v(" "), _vm._m(5), _vm._v(" "), _vm._m(6), _vm._v(" "), _vm._m(7)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_vm._v("npm install vux --save\n")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("或者使用 "), _c('code', [_vm._v("yarn")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_vm._v("yarn add vux "), _c('span', {
    staticClass: "hljs-comment"
  }, [_vm._v("// 安装")]), _vm._v("\nyarn upgrade vux "), _c('span', {
    staticClass: "hljs-comment"
  }, [_vm._v("// 更新")]), _vm._v("\n")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("如果你想直接从 Github 安装，请指定 "), _c('code', [_vm._v("v2")]), _vm._v(" 分支")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_vm._v("npm install git://github.com/airyland/vux.git"), _c('span', {
    staticClass: "hljs-comment"
  }, [_vm._v("#v2")]), _vm._v("\n")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "warning"
  }, [_c('p', [_vm._v("vux2必须配合"), _c('code', [_vm._v("vux-loader")]), _vm._v("使用, 请在"), _c('code', [_vm._v("build/webpack.base.conf.js")]), _vm._v("里参照如下代码进行配置：")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("const")]), _vm._v(" vuxLoader = "), _c('span', {
    staticClass: "hljs-built_in"
  }, [_vm._v("require")]), _vm._v("("), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'vux-loader'")]), _vm._v(")\n"), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("const")]), _vm._v(" webpackConfig = originalConfig "), _c('span', {
    staticClass: "hljs-comment"
  }, [_vm._v("// 原来的 module.exports 代码赋值给变量 webpackConfig")]), _vm._v("\n\n"), _c('span', {
    staticClass: "hljs-built_in"
  }, [_vm._v("module")]), _vm._v(".exports = vuxLoader.merge(webpackConfig, {\n  "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("plugins")]), _vm._v(": ["), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'vux-ui'")]), _vm._v("]\n})\n")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "warning"
  }, [_c('p', [_vm._v("vux@0.x 已经停止维护，请尽快迁移到 vue@2.x & vuex@2.x & vux@2.x，虽然要花点时间，但是完全值得。")])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-28ca0010", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/ream/~/vue-loader/lib/template-compiler?{"id":"data-v-28ca0010"}!./~/ream/~/vue-loader/lib/selector.js?type=template&index=0!./~/v-markdown-loader/_cache/npm-170.vue
// module id = 2103
// module chunks = 419